import { Badge } from "@/components/shadcn/badge";

type ConnectionStatusBadgeProps = {
  isConnected: boolean;
  isEnabled: boolean;
};

export const ConnectionStatusBadge = ({ isConnected, isEnabled }: ConnectionStatusBadgeProps) => {
  if (!isConnected) {
    return <Badge variant="secondary">Not connected</Badge>;
  }

  return isEnabled
    ? <Badge variant="success">Connected</Badge>
    : <Badge variant="destructive">Paused</Badge>;
};
